export type CompareOptions = 'GREATER_EQUAL' | 'LOWER_EQUAL' | 'EQUAL';

export interface AnalyticsCondition {
  name: string, // case sensitive
  compare: CompareOptions,
  amount: number,
}

export const COMPARATORS: any = {
  "GREATER_EQUAL": (a: number, b: number) => a >= b,
  "LOWER_EQUAL": (a: number, b: number) => a <= b,
  "EQUAL": (a: number, b: number) => a === b,
};
